import { Directive } from '@angular/core';
@Directive({
  selector: '[fActivityContainer]',
  standalone: false
})
export class ActivityContainerDirective {}
